import { render, staticRenderFns } from "./TestTreeTable.vue?vue&type=template&id=ec313f80&scoped=true"
import script from "./TestTreeTable.vue?vue&type=script&lang=js"
export * from "./TestTreeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec313f80",
  null
  
)

export default component.exports